import * as React from "react"

// @ts-ignore
import styles from "./ContactCard.module.scss"
// @ts-ignore
import phoneIcon from "../../../../assets/phone-icon.svg"

const phoneNumber = "08-23 01 23"

const ContactCard = ({ mobileNav }) => {
  return (
    <div className={styles.ContactCard}>
      <div
        className={
          mobileNav
            ? styles.regularDisplayWrapperMobileNav
            : styles.regularDisplayWrapper
        }
      >
        <div
          className={mobileNav ? styles.textWrapperMobile : styles.textWrapper}
        >
          <span className={styles.text}>
            Beställ via telefon <span className={styles.orangeDot}>·</span>{" "}
            Allmänna Frågor
          </span>

          <span className={styles.bottomTextWrapper}>
            <span className={styles.workHours}>Telefontider 9.00 - 17.00</span>
            <span className={styles.orangePipe}>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <span className={styles.phoneNumber}>{phoneNumber}</span>
          </span>
        </div>

        <div
          className={
            mobileNav ? styles.iconWrapperMobileNav : styles.iconWrapper
          }
        >
          <img src={phoneIcon} alt='phone icon' />
        </div>
      </div>

      <div className={mobileNav ? styles.noShow : styles.mobileDisplayWrapper}>
        <div className={styles.mobileIconWrapper}>
          <img src={phoneIcon} alt='phone icon' />
        </div>

        <div className={styles.phoneNumberMobile}>{phoneNumber}</div>
      </div>
    </div>
  )
}

export default ContactCard
